import type { FragmentType } from '~/lib/graphql'
import { getFragmentData, graphql } from '~/lib/graphql'

const SeatForLabel = graphql(`
  fragment SeatForLabel on Seat {
    seatTypeLabel
    smokingAllowed
    attributes
  }
`)

const SEAT_ATTRIBUTE_VALUES = {
  COUPLE_SEAT: 'カップルシート',
  KAWADOKO: '川床',
  KOTATSU: '掘りごたつ',
  PRIVATE_TABLE: 'テーブル',
  SOFA: 'ソファー',
  WINDOW_SEAT: '窓側',
  ZASHIKI: '座敷',
}

export function seatLabel(seat: FragmentType<typeof SeatForLabel>) {
  const {
    attributes: seatAttributes,
    seatTypeLabel,
    smokingAllowed,
  } = getFragmentData(SeatForLabel, seat)
  const attributes = seatAttributes.length > 0 ? `（${joinAttributes(seat)}）` : ''
  return `${seatTypeLabel}${attributes} ／ ${smokingAllowedText(smokingAllowed)}`
}
if (import.meta.vitest) {
  const { it, expect } = import.meta.vitest
  it('seatLabel', () => {
    const seat = {
      seatTypeLabel: 'テーブル',
      smokingAllowed: true,
      attributes: ['COUPLE_SEAT', 'PRIVATE_TABLE'],
    } as FragmentType<typeof SeatForLabel>
    expect(seatLabel(seat)).toBe('テーブル（カップルシート・テーブル） ／ 喫煙')
  })
}

function joinAttributes(seat: FragmentType<typeof SeatForLabel>) {
  const { attributes } = getFragmentData(SeatForLabel, seat)
  if (attributes.length === 0) {
    return ''
  }
  return attributes.map((attribute) => SEAT_ATTRIBUTE_VALUES[attribute]).join('・')
}
if (import.meta.vitest) {
  const { it, expect } = import.meta.vitest
  it('joinAttributes', () => {
    const seat = {
      attributes: ['COUPLE_SEAT', 'PRIVATE_TABLE', 'KAWADOKO'],
    } as FragmentType<typeof SeatForLabel>
    expect(joinAttributes(seat)).toBe('カップルシート・テーブル・川床')
  })
}

function smokingAllowedText(smokingAllowed: boolean) {
  return smokingAllowed ? '喫煙' : '禁煙'
}
if (import.meta.vitest) {
  const { it, expect } = import.meta.vitest
  it('smokingAllowedText', () => {
    expect(smokingAllowedText(true)).toBe('喫煙')
    expect(smokingAllowedText(false)).toBe('禁煙')
  })
}
